
export enum AppMode {
  WASTEMAP = 'wastemap',
  WASTEMAP_MANAGER = 'manager'
}

export enum UserProfile {
  CITIZEN = 'Usuário',
  COLLECTOR = 'Catador',
  COMPANY = 'Empresa',
  ATTENDANT = 'Atendente',
  MANAGER = 'Administrador'
}

export enum CategoriaConteudo {
  RECICLAGEM = 'Reciclagem',
  MEIO_AMBIENTE = 'Meio Ambiente',
  LOGISTICA_REVERSA = 'Logística Reversa',
  CURIOSIDADES = 'Curiosidades'
}

export interface PartnerTheme {
  id: string;
  nome_parceiro: string;
  nome_projeto?: string;
  cor_principal: string;
  cor_secundaria: string;
  logo_parceiro?: string | null;
  total_descartes?: number;
}

export interface QuizAlternative {
  id: string;
  quiz_id: string;
  pergunta_id: string;
  resposta: string;
  verdadeira: boolean;
  imagem?: string;
  ordem: number;
  data_registro?: string;
}

export interface QuizQuestion {
  id: string;
  quiz_id: string;
  pergunta: string;
  imagem_url?: string;
  ordem: number;
  data_registro?: string;
  data_atualizacao?: string;
  alternativas?: QuizAlternative[];
}

export interface Quiz {
  id: string;
  titulo: string;
  status: 'EM_ELABORACAO' | 'ATIVO' | 'INATIVO';
  pontos: number;
  cashback: number;
  exp: number;
  data_registro?: string;
  perguntas?: QuizQuestion[];
  ecopontos?: string[]; // IDs of linked ecopontos
}

export interface QuizUserResponse {
  id: string;
  user_id: string;
  quiz_id: string;
  resposta_id: string;
  resposta: string;
  correta: boolean;
  pontos: number;
  cashback: number;
  local: 'APP' | 'TOTEM' | 'WEB' | 'CAMPANHA';
  ecoponto_id?: string;
  data_registro: string;
}

export interface Parceiro {
  id: string;
  nome_parceiro: string;
  email?: string;
  celular?: string;
  cnpj_parceiro?: string;
  descricao_parceiro?: string;
  cidade_parceiro?: string;
  uf_parceiro?: string;
  endereco_parceiro?: string;
  apelido_pontos?: string;
  nome_projeto?: string;
  tipo_projeto?: string;
  cor_principal?: string;
  cor_secundaria?: string;
  logo_parceiro?: string;
  img_capa_parceiro?: string;
  status_ativo?: boolean;
  sistema_ranking?: boolean;
  data_registro?: string;
}

export interface UsuarioPrograma {
  id: string;
  usuario_id: string;
  parceiro_id: string;
  descartes: number;
  qtd_itens_desc: number;
  qtd_kg_desc: number;
  pontos: number;
  data_registro?: string;
}

export interface Ranking {
  id: string;
  tipo: 'MENSAL' | 'GLOBAL';
  criterio: 'VOLUME' | 'DESCARTES' | 'PONTOS';
  ano: number;
  mes: number;
  parceiro_id?: string;
  data_registro: string;
  data_atualizacao: string;
}

export interface RankingUser {
  id: string;
  ranking_id: string;
  usuario_id: string;
  nome: string;
  email: string;
  pontos: number;
  descartes: number;
  volume: number;
  posicao: number;
  mes: number;
  ano: number;
  tipo: 'MENSAL' | 'GLOBAL';
  data_registro: string;
  data_atualizacao: string;
}

export interface Loja {
  id: string;
  parceiro_id: string;
  gestor_loja_id: string;
  loja_nome: string;
  descricao?: string;
  endereco?: string;
  loja_logo?: string;
  qtd_recompensas: number;
  dados_completos: boolean;
  status_ativo: boolean;
  data_registro?: string;
}

export interface ThemeState {
  isDark: boolean;
}

export interface Liga {
  id: string;
  nome: string;
  nivel: number;
  cor?: string;
  icone?: string;
  qtd_promove?: number;
  qtd_rebaixa?: number;
  capacidade_usuarios?: number;
  data_registro?: string;
  xp_minimo?: number;
  xp_maximo?: number;
}

export interface RankingLiga {
  id: string;
  usuario_id: string;
  liga_id: string;
  xp_periodo: number;
  posicao?: number;
  periodo_inicio: string;
  periodo_fim: string;
  data_registro?: string;
  data_atualizacao?: string;
  sequencia?: number;
  usuarios?: {
    nome: string;
    photo_url?: string;
    sequencia: number;
    qtd_descartes: number;
    exibir_liga?: boolean;
  };
}

export interface UsuarioLiga {
  id: string;
  usuario_id: string;
  liga_id: string;
  xp_total: number;
  data_entrada?: string;
  ligas?: Liga;
  xp_periodo?: number;
}

export interface UsuarioLigaHistorico {
  id: string;
  usuario_id: string;
  liga_anterior_id?: string;
  liga_nova_id?: string;
  tipo: 'PROMOÇÃO' | 'REBAIXAMENTO' | 'ENTRADA';
  data_movimentacao?: string;
}

export enum ColetaStatus {
  PENDENTE = 'PENDENTE',
  ACEITA = 'ACEITA',
  EM_ROTA = 'EM_ROTA',
  CONCLUIDA = 'CONCLUIDA',
  CANCELADA = 'CANCELADA'
}

export interface Coleta {
  id: string;
  usuario_id: string;
  catador_id?: string;
  residuo_nome?: string;
  celular?: string;
  descricao: string;
  volume_estimado: string;
  foto_url?: string;
  endereco: string;
  latitude: number;
  longitude: number;
  status: ColetaStatus;
  data_solicitacao: string;
  data_aceite?: string;
  data_conclusao?: string;
  data_registro: string;
  // Join fields
  usuarios?: {
    nome: string;
    photo_url?: string;
    celular?: string;
  };
  catadores?: {
    nome: string;
    photo_url?: string;
  };
}

export interface ColetaHistorico {
  id: string;
  coleta_id: string;
  status: ColetaStatus;
  descricao: string;
  usuario_id: string;
  data_registro: string;
}

export interface ColetaInteracao {
  id: string;
  coleta_id: string;
  catador_id: string;
  status: 'ACEITOU' | 'RECUSOU' | 'VISUALIZOU';
  data_registro: string;
}

export type EventType = 'DESCARTE' | 'VISUALIZACAO' | 'QUIZ' | 'OUTRO' | 'ECOPONTO' | 'MATERIAL';
export type MilestoneType = 'DESCARTES' | 'PONTOS' | 'VOLUME' | 'MISSOES_CONCLUIDAS';

export interface Missao {
  id: string;
  nome: string;
  nivel_jornada: number;
  imagem_missao: string;
  cashback: number;
  pontos: number;
  exp: number;
  status: string;
  data_inicio?: string;
  data_fim?: string;
  programas: string[];
  data_registro: string;
}

export interface MissaoEvento {
  id: string;
  missao_id: string;
  nome: string;
  tipo_evento: EventType;
  ecoponto_id?: string;
  material_id?: string;
  conteudo_educacional_id?: string;
  quiz_id?: string;
  meta_quantidade: number;
  data_registro: string;
  data_atualizacao: string;
}

export interface MissaoUser {
  id: string;
  usuario_id: string;
  missao_id: string;
  nome_missao: string;
  progresso: number;
  pontos: number;
  cashback: number;
  exp: number;
  recompensa_recebida: boolean;
  concluida: boolean;
  data_registro: string;
  data_conclusao?: string;
}

export interface MissaoUserEvento {
  id: string;
  missao_user_id: string;
  evento_id: string;
  progresso_atual: number;
  concluido: boolean;
  data_registro: string;
  data_conclusao?: string;
}

export interface Medalha {
  id: string;
  missao_id: string;
  titulo: string;
  descricao: string;
  imagem_medalha: string;
}

export interface MedalhaUser {
  id: string;
  usuario_id: string;
  medalha_id: string;
  missao_id: string;
  imagem_medalha: string;
  conquistado_em: string;
}

export interface Conquista {
  id: string;
  titulo: string;
  descricao: string;
  imagem_url: string;
  tipo_marco: MilestoneType;
  valor_marco: number;
  pontos: number;
  ativa: boolean;
  data_registro: string;
}

export interface ConquistaUser {
  id: string;
  usuario_id: string;
  conquista_id: string;
  imagem_url: string;
  conquistado_em: string;
}

export interface AppParams {
  id: string;
  termos: string;
  privacidade: string;
  email_suporte: string;
  telefone_suporte: string;
  termos_version: number;
}

export interface ParametrosGerais {
  id: string;
  checkin_bonus: number;
  checkin_streak_10_bonus: number;
  min_points_cashback: number;
  points_per_kg_base: number;
  conversao_pontos: number;
  data_atualizacao: string;
}

export interface MaterialValores {
  id: string;
  material_id: string;
  valor: number;
  vigencia_inicio: string;
  vigencia_fim?: string;
  data_registro: string;
  data_atualizacao: string;
}

export interface UsuarioPontos {
  id: string;
  usuario_id: string;
  origem: 'CHECKIN' | 'QUIZ' | 'DESCARTE' | 'MISSAO' | 'CONQUISTA' | 'BONUS' | 'CAMPANHA' | 'AJUSTE' | 'ESTORNO' | 'EXPIRACAO';
  referencia_id?: string;
  tipo_ponto: 'CREDITO' | 'DEBITO';
  quantidade_pontos: number;
  peso_financeiro: number;
  valor_unitario?: number;
  valor_total: number;
  status: 'PENDENTE' | 'CONSOLIDADO' | 'CANCELADO' | 'LIQUIDADO';
  data_registro: string;
  data_atualizacao: string;
}

export interface UsuarioPontosSaldo {
  id: string;
  usuario_id: string;
  total_pontos_credito: number;
  total_pontos_debito: number;
  saldo_pontos: number;
  total_valor_credito: number;
  total_valor_debito: number;
  saldo_valor: number;
  data_registro: string;
  data_atualizacao: string;
}

export interface EasyInstance {
  id: string;
  nome: string;
  cidade?: string | null;
  estado?: string | null;
  empresa?: string | null;
  slug: string;
  url: string;
  status: 'ATIVO' | 'INATIVO';
  ambiente: 'PRODUCAO' | 'HOMOLOGACAO' | 'DESENVOLVIMENTO';
  versao: string;
  observacoes?: string | null;
  data_registro: string;
  data_atualizacao: string;
}
